import React, { useState, useEffect, useContext } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import axios from 'axios';
import { AuthContext } from '../App';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DebugAuth = () => {
  const { user, hasAccess, checkAuth } = useContext(AuthContext);
  const [authData, setAuthData] = useState(null);

  useEffect(() => {
    fetchAuthData();
  }, []);

  const fetchAuthData = async () => {
    try {
      const response = await axios.get(`${API}/auth/check`, {
        withCredentials: true
      });
      setAuthData(response.data);
    } catch (error) {
      setAuthData({ error: error.response?.data?.detail || error.message });
    }
  };

  const handleRefresh = () => {
    checkAuth();
    fetchAuthData();
  };

  return (
    <div className="min-h-screen p-8" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <Card className="glass border-white/20 max-w-3xl mx-auto">
        <CardHeader>
          <CardTitle className="text-2xl text-white">Authentication Debug Panel</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div>
            <h3 className="text-white font-semibold mb-2">Context State:</h3>
            <pre className="bg-black/30 p-4 rounded text-white text-sm overflow-auto">
              {JSON.stringify({ user, hasAccess }, null, 2)}
            </pre>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-2">API Response (/auth/check):</h3>
            <pre className="bg-black/30 p-4 rounded text-white text-sm overflow-auto">
              {JSON.stringify(authData, null, 2)}
            </pre>
          </div>

          <div className="space-y-2">
            <h3 className="text-white font-semibold">Access Status:</h3>
            <div className="bg-black/30 p-4 rounded space-y-2">
              <p className="text-white">
                <strong>Has Access:</strong> {hasAccess ? '✅ YES' : '❌ NO'}
              </p>
              <p className="text-white">
                <strong>User Role:</strong> {user?.role || 'N/A'}
              </p>
              <p className="text-white">
                <strong>Subscription Status:</strong> {user?.subscription_status || 'N/A'}
              </p>
              <p className="text-white">
                <strong>Trial Ends:</strong> {user?.free_trial_ends_at ? new Date(user.free_trial_ends_at).toLocaleString() : 'N/A'}
              </p>
            </div>
          </div>

          <Button
            onClick={handleRefresh}
            className="w-full bg-white text-purple-700 hover:bg-gray-100"
          >
            Refresh Auth Data
          </Button>

          <div className="bg-yellow-500/20 border border-yellow-500/40 rounded p-4">
            <p className="text-white text-sm">
              <strong>Note:</strong> If hasAccess is false but you have a valid trial, there's a bug in the access check logic.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DebugAuth;
